import V2 from "./v2/App";

export default function Entry(props) {
    return <V2 {...props} />;
}
